module.exports = __webpack_public_path__ + "media/images/gallery/constellations/corvus/crv_lines-c046c2a7955bb719932989d4605aa0f6.gif";